import { Select, SelectProps } from 'antd';
import './index.scss';

interface CustomSelectProps<T = any> extends SelectProps<T> {}

const CustomSelect = <T extends any>(props: CustomSelectProps<T>) => {
  return (
    <Select
      {...props}
      className={`ant-custom-select ${props.className}`}
      getPopupContainer={(trigger: any) => trigger.parentNode}
      placeholder={props?.placeholder ? props.placeholder : undefined}
      suffixIcon={props?.suffixIcon}
    />
  );
};

export default CustomSelect;
